export default {
  listLabel: {
    footerText1:
      'Price: x 1,000. Volume: x 1,000. Value: x 1,000,000. Date marked with the arterisk are Exercise Date.',
    footerText2: 'Price: x 1,000. Volume: x 1,000. Value: x 1,000,000',
  },

  tab: {
    LastWeek: 'Last Week',
    LastMonth: 'Last Month',
    ThisWeek: 'This Week',
    ThisMonth: 'This Month',
    NextWeek: 'Next Week',
    NextMonth: 'Next Month',
  },

  listFilterEvent: {
    ern: 'ERN',
    div: 'DIV',
    sis: 'SIS',
    ipo: 'LIS',
    agm: 'AGM',
  },

  listFilterEventTooltip: {
    ern: 'Earnings',
    div: 'Dividends',
    sis: 'Share Issuance',
    ipo: 'Listing',
    agm: 'Annual General Meeting',
  },

  marketCarlendarErnTable: {
    //ern
    TICKER: 'TICKER',
    COMPANY: 'COMPANY',
    REVENUE: 'REVENUE(BN.)',
    REV: 'REV. (BN.)<br> (FORECAST)',
    PROFIT: 'PROFIT (BN.)',
    PROFIT_FORECAT: 'PROFIT (BN.)<br> (FORECAST)',
    PERFORMANCE: 'PERFORMANCE',
    INTERIM: 'INTERIM',
  },

  marketCarlendarDivCashTable: {
    TICKER: 'TICKER',
    AN_DATE: 'AN. DATE',
    EX_RIGHT_DATE: 'EX-RIGHTS DATE',
    RECORD_DATE: 'RECORD DATE',
    PAYOUT_DATE: 'PAYOUT DATE',
    EX_RATIO: 'EX-RATIO',
    VALUE: 'VALUE',
    DIV_YEAR: 'DIV. YEAR',
    DIV_TYPE: 'DIV. TYPE',
    PERFORMANCE: 'PERFORMANCE',
    REFERENCE: 'REFERENCE',
  },

  marketCarlendarDivStockTable: {
    TICKER: 'TICKER',
    AN_DATE: 'AN. DATE',
    EX_RIGHT_DATE: 'EX-RIGHTS DATE',
    RECORD_DATE: 'RECORD DATE',
    PAYOUT_DATE: 'PAYOUT DATE',
    EX_RATIO: 'EX-RATIO',
    DIV_YEAR: 'DIV. YEAR',
    DIV_TYPE: 'DIV. TYPE',
    PERFORMANCE: 'PERFORMANCE',
    REFERENCE: 'REFERENCE',
  },

  marketCarlendarSisTable: {
    TICKER: 'TICKER',
    ANNOUNCEMENT_DATE: 'An. Date',
    EX_RIGHTS_DATE: 'EX-RIGHTS DATE',
    ISSUE_DATE: 'ISSUE DATE',
    LISTING_DATE: 'LISTING DATE',
    ISSUE_METHOD: 'ISSUE METHOD',
    ISSUE_PERCEN: '% ISSUE',
    ISSUE_VOLUMN: 'ISSUE VOLUME',
    YEAR: 'YEAR',
    STATUS: 'STATUS',
  },

  marketCarlendarIpoTable: {
    TICKER: 'TICKER',
    COMPANY: 'COMPANY',
    AN_DATE: 'AN. DATE',
    LISTING_DATE: 'LISTING DATE',
    EXCHANGE: 'EXCHANGE',
    OFFERING_SHARES: 'OFFERING SHARES',
    IPO_RATIO: 'IPO RATIO',
    PRICE: 'PRICE',
    REVIPO: 'REV. (BN.)',
    PROFIT: 'PROFIT (BN.)',
  },

  marketCarlendarLisTable: {
    TICKER: 'TICKER',
    COMPANY: 'COMPANY',
    AN_DATE: 'AN. DATE',
    RECORD_DATE: 'RECORD DATE',
    EX_RIGHT_DATE: 'EX-RIGHT DATE',
    EXERCISE_DATE: 'EXERCISE DATE',
    LISTING_TYPE: 'LISTING TYPE',
    PERFORMANCE: 'PERFORMANCE',
  },

  marketCarlendarAgmTable: {
    TICKER: 'TICKER',
    COMPANY: 'COMPANY',
    DATE: 'An. Date',
    EX_DIV_DATE: 'EXRIGHT DATE',
    VENUE: 'VENUE',
    LOCATION: 'LOCATION',
    SOURCE: 'SOURCE',
  },
  tableTitle: {
    cashDividend: 'CASH DIVIDEND',
    stockDividend: 'STOCK DIVIDEND',
    newListing: 'NEW LISTING',
    otherListing: 'OTHERS',
  },

  timeRange: 'Time Range',
  timeRangeFilter: {
    from: 'From',
    to: 'To',
  },
  lastestQuarter: 'Lastest Quarter',
  forecastForCurrentYear: 'Forecast for current year',
};
